import script from "./BugManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./BugManagement.vue?vue&type=script&setup=true&lang=js"

import "./BugManagement.vue?vue&type=style&index=0&id=6c46498c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c46498c"]])

export default __exports__